/*
 * Camada HTTP unica do frontend.
 * Regra Babita: nenhuma chamada fora daqui. Respostas seguem { Error: 'msg' } ou dados puros.
 */

const BASE = (process.env.REACT_APP_API_URL || `${process.env.REACT_APP_SERVER_IP || 'http://192.168.0.204'}:${process.env.REACT_APP_SERVER_PORT || '3010'}`).replace(/\/+$/, '');

async function post(path, body) {
    try {
        const resp = await fetch(`${BASE}${path}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body || {})
        });
        // tenta ler JSON do body (backend manda {Error:'msg'} mesmo em 500)
        const ct = resp.headers.get('content-type') || '';
        if (ct.includes('application/json')) {
            const j = await resp.json();
            if (!resp.ok && !j.Error) j.Error = `HTTP ${resp.status}`;
            return j;
        }
        // sem JSON: tenta ler texto
        const txt = await resp.text().catch(() => '');
        if (!resp.ok) return { Error: `HTTP ${resp.status}${txt ? ': ' + txt.slice(0, 240) : ''}` };
        return { raw: txt };
    } catch (e) {
        return { Error: e.message || 'Falha de rede.' };
    }
}

async function get(path) {
    try {
        const resp = await fetch(`${BASE}${path}`);
        const ct = resp.headers.get('content-type') || '';
        if (ct.includes('application/json')) {
            const j = await resp.json();
            if (!resp.ok && !j.Error) j.Error = `HTTP ${resp.status}`;
            return j;
        }
        const txt = await resp.text().catch(() => '');
        if (!resp.ok) return { Error: `HTTP ${resp.status}${txt ? ': ' + txt.slice(0, 240) : ''}` };
        return { raw: txt };
    } catch (e) {
        return { Error: e.message || 'Falha de rede.' };
    }
}

// Auth
export const ConsultaUsuario = (b) => post('/ConsultaUsuario', b);

// Dashboard
export const ConsultaDashboard = (b) => post('/ConsultaDashboard', b);
export const SalvaDashboard    = (b) => post('/SalvaDashboard', b);
export const ExportaPreset       = (b) => post('/ExportaPreset', b);
export const RenomeiaPreset       = (b) => post('/RenomeiaPreset', b);
export const DefinePresetPadrao   = (b) => post('/DefinePresetPadrao', b);
export const ConsultaPresetsPadrao = (b) => post('/ConsultaPresetsPadrao', b);
export const SincronizaPreset    = (b) => post('/SincronizaPreset', b);
export const ReVinculaPresets    = (b) => post('/ReVinculaPresets', b);

// Crontab
export const ConsultaRotinas = (b) => post('/ConsultaRotinas', b);
export const SalvaRotina     = (b) => post('/SalvaRotina', b);
export const ExecutaRotina   = (b) => post('/ExecutaRotina', b);
export const RemoveRotina    = (b) => post('/RemoveRotina', b);

// Internas
export const ConsultaInternas    = (b) => post('/ConsultaInternas', b);
export const SalvaInternaEstatica = (b) => post('/SalvaInternaEstatica', b);
export const RemoveInterna       = (b) => post('/RemoveInterna', b);
export const ArquivaInterna      = (b) => post('/ArquivaInterna', b);
export const ConsultaInternasGrupos = (b) => post('/ConsultaInternasGrupos', b);
export const SalvaInternasGrupos    = (b) => post('/SalvaInternasGrupos', b);
export const ExecutaTelaInterna  = (b) => post('/ExecutaTelaInterna', b);
export const ExecutaConsultaSql  = (b) => post('/ExecutaConsultaSql', b);

// Arquivos
export const ConsultaArquivos   = (b) => post('/ConsultaArquivos', b);
export const ConsultaMonitor    = (b) => post('/ConsultaMonitor', b);

// iter9.2: TTS via Piper Cadu (pt_BR). Retorna Blob de audio/wav.
export async function AssistenteVozFalar(body) {
    const r = await fetch(`${BASE}/AssistenteVozFalar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {})
    });
    const ct = r.headers.get('content-type') || '';
    if (!r.ok || !ct.startsWith('audio/')) {
        try { return await r.json(); } catch { return { Error: `HTTP ${r.status}` }; }
    }
    return await r.blob();
}
export const ConsultaFileServer = (b) => post('/ConsultaFileServer', b);
export const SalvaFileServer    = (b) => post('/SalvaFileServer', b);
export const ListaArquivosSamba = (b) => post('/ListaArquivosSamba', b);
export const TestaSambaConexao  = (b) => post('/TestaSambaConexao', b);
// Acesso a Arquivos (TI): contas Samba e a conta de cada pessoa
export const ConsultaAcessoArquivos = (b) => post('/ConsultaAcessoArquivos', b);
export const SalvaContaSamba    = (b) => post('/SalvaContaSamba', b);
export const RemoveContaSamba   = (b) => post('/RemoveContaSamba', b);
export const AssociaContaSamba  = (b) => post('/AssociaContaSamba', b);
export const SalvaSambaPropria  = (b) => post('/SalvaSambaPropria', b);
export const TestaContaSamba    = (b) => post('/TestaContaSamba', b);
export const ListaUsuariosSamba = (b) => post('/ListaUsuariosSamba', b); // os usuarios que ja existem no servidor (so nomes)

// Logs / Alertas / Config pessoal
export const ConsultaLogs       = (b) => post('/ConsultaLogs', b);
export const ConsultaAlertas    = (b) => post('/ConsultaAlertas', b);
export const ResolveAlerta      = (b) => post('/ResolveAlerta', b);
export const ResolveTodosAlertas = (b) => post('/ResolveTodosAlertas', b);
export const ReabreAlerta       = (b) => post('/ReabreAlerta', b);
export const ConsultaPrefsAlertas = (b) => post('/ConsultaPrefsAlertas', b);
export const SalvaPrefsAlertas    = (b) => post('/SalvaPrefsAlertas', b);
export const SalvaConfigPessoal = (b) => post('/SalvaConfigPessoal', b);
export const AlteraSenha        = (b) => post('/AlteraSenha', b);

// TI
export const ConsultaLogins      = (b) => post('/ConsultaLogins', b);
export const CriaUsuario         = (b) => post('/CriaUsuario', b);
export const AtualizaUsuario     = (b) => post('/AtualizaUsuario', b);
export const DefineSenha         = (b) => post('/DefineSenha', b);
export const BloqueiaUsuario     = (b) => post('/BloqueiaUsuario', b);
export const ConsultaPermissoes  = (b) => post('/ConsultaPermissoes', b);
export const SalvaPermissoes     = (b) => post('/SalvaPermissoes', b);
export const ConsultaConexoes    = (b) => post('/ConsultaConexoes', b);
export const SalvaConexao        = (b) => post('/SalvaConexao', b);
export const RemoveConexao       = (b) => post('/RemoveConexao', b);
export const ValidaConexao       = (b) => post('/ValidaConexao', b);
export const ConsultaConstrutor  = (b) => post('/ConsultaConstrutor', b);
export const PublicaTela         = (b) => post('/PublicaTela', b);
export const ConsultaTelegram    = (b) => post('/ConsultaTelegram', b);
export const SalvaCanalTelegram  = (b) => post('/SalvaCanalTelegram', b);
export const ConsultaSmtp       = (b) => post('/ConsultaSmtp', b);
export const SalvaSmtp          = (b) => post('/SalvaSmtp', b);
export const TestaSmtp          = (b) => post('/TestaSmtp', b);
export const EnviaNotificacao   = (b) => post('/EnviaNotificacao', b);
export const SalvaBotTelegram   = (b) => post('/SalvaBotTelegram', b);
export const ConsultaAcessosTelegram = (b) => post('/ConsultaAcessosTelegram', b);
export const SalvaAcessosTelegram    = (b) => post('/SalvaAcessosTelegram', b);
export const TestaTelegram      = (b) => post('/TestaTelegram', b);
export const DescobreChatsTelegram = (b) => post('/DescobreChatsTelegram', b);


export const MontaPanorama      = (b) => post('/MontaPanorama', b);
export const ConsultaPanorama   = (b) => post('/ConsultaPanorama', b);
export const SalvaPanorama      = (b) => post('/SalvaPanorama', b);
export const VinculaTelegramGera = (b) => post('/VinculaTelegramGera', b);
export const TelegramPareamento  = (b) => post('/TelegramPareamento', b);

export const BaixaArquivoSamba  = (b) => post('/BaixaArquivoSamba', b);

export const ConsultaTemplatesNotif = (b) => post('/ConsultaTemplatesNotif', b);
export const SalvaTemplateNotif  = (b) => post('/SalvaTemplateNotif', b);
export const RemoveTemplateNotif = (b) => post('/RemoveTemplateNotif', b);
export const ResolveTemplateNotif = (b) => post('/ResolveTemplateNotif', b);

export const health = () => get('/health');

// Memoria (conector Babita)
export const ConsultaPermissoesMemoria = (b) => post('/ConsultaPermissoesMemoria', b);
export const ConsultaNotasMemoria      = (b) => post('/ConsultaNotasMemoria', b);
export const SalvaPermissoesMemoria    = (b) => post('/SalvaPermissoesMemoria', b);
export const ConsultaSessoesMemoria    = (b) => post('/ConsultaSessoesMemoria', b);
export const RevogaSessaoMemoria       = (b) => post('/RevogaSessaoMemoria', b);
